<template>
  <div style="display:flex; min-height:100vh; position:relative;">
    
    <Sidebar :is-open="sidebarOpen" @close="sidebarOpen = false" />

    <!-- Hamburger: sits just outside the collapsed sidebar, hidden when expanded -->
    <button
      v-show="!sidebarOpen"
      class="sidebar-toggle-btn"
      @click="sidebarOpen = true"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div
      class="main-content-area"
      :style="{ marginLeft: sidebarOpen ? '260px' : '60px' }"
    >
      <router-view />
    </div>

  </div>
</template>

<script>
import Sidebar from '../components/Sidebar.vue';

export default {
  name: 'MainLayout',
  components: { Sidebar },
  data() {
    return { sidebarOpen: true }
  }
}
</script>

<style scoped>
.main-content-area {
  flex: 1;
  min-width: 0;
  min-height: 100vh;
  transition: margin-left 0.3s ease;
  background: #f8fafc;
}

.sidebar-toggle-btn {
  position: fixed;
  top: 14px;
  left: 10px;
  z-index: 200;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 7px 9px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  transition: left 0.3s ease; /* matches sidebar width transition */
}

.sidebar-toggle-btn span {
  display: block;
  width: 20px;
  height: 2px;
  background: #64748b;
  border-radius: 2px;
}

.sidebar-toggle-btn:hover {
  background: #f8fafc;
}

.sidebar-toggle-btn:hover span {
  background: #4f46e5;
}
</style>